import logger from '../../log';
import { stringify } from '../utils/stringify';
import isEdge from './isEdge';
import { noop } from '../constants';

const log = logger.getLogger(__filename);

function addTimeout(request, timeout, onTimeout, ignoreEdgeTimeout) {
  const edge = isEdge();
  if (timeout <= 0 || (edge && ignoreEdgeTimeout)) {
    return;
  }

  const onTimeoutWrapper = function() {
    // If on Edge, check if somehow the request already reached the DONE state
    if (edge && request.readyState === XMLHttpRequest.DONE) {
      return;
    }

    request.onreadystatechange = null; // Disconnects callbacks
    if (!edge) {
      request.abort();
    }
    onTimeout(request);
  };

  if (edge) {
    // Edge freezes after too many requests are aborted (see DEV-34962), so just manually timeout without aborting
    setTimeout(onTimeoutWrapper, timeout);
  } else {
    request.ontimeout = onTimeoutWrapper;
    request.timeout = timeout;
  }
}

export default function(options) {
  const method = options.method || 'GET';
  const url = options.url + stringify(options.params, true);
  const headers = options.headers || {};
  const expectJson = options.expectJson == null ? true : options.expectJson;
  const jsonContent = options.jsonContent == null ? true : options.jsonContent;
  const async = options.async == null ? true : options.async;
  const onSuccess = options.onSuccess || noop;
  const onFailure = options.onFailure || noop;
  const onTimeout = options.onTimeout || noop;
  const timeout = options.timeout || 0;
  const body = options.body;
  // Edge only: whether to do manual timeout (falsey) or wait for request resolution (true)
  const ignoreEdgeTimeout = options.ignoreEdgeTimeout;

  const request = new XMLHttpRequest();
  request.onreadystatechange = () => {
    if (request && request.readyState === XMLHttpRequest.DONE) {
      if (request.status >= 200 && request.status < 400) {
        try {
          const data =
            expectJson && request.responseText
              ? // This needs a catch block
                JSON.parse(request.responseText)
              : request.responseText;
          onSuccess(data, request);
        } catch (e) {
          log.error('Failed to parse response', e);
          log.info('Failed to parse response request:', request);
          onFailure(request);
        }
      } else if (request.status >= 400) {
        onFailure(request);
      } else if (request.status < 100) {
        // Ensure the onTimeoutWrapper is called before this; otherwise, all non-Edge timeouts are reported as failure
        setImmediate(() => {
          if (request.onreadystatechange) {
            onFailure(request);
          }
        });
      }
    }
  };
  request.open(method, url, async);
  addTimeout(request, timeout, onTimeout, ignoreEdgeTimeout);

  if (options.withCredentials) {
    request.withCredentials = options.withCredentials;
  }

  if (expectJson) {
    request.setRequestHeader('Accept', 'application/json');
  }

  if (method !== 'GET' && jsonContent) {
    request.setRequestHeader('Content-Type', 'application/json');
  }

  // Set headers
  Object.getOwnPropertyNames(headers).forEach(key => {
    request.setRequestHeader(key, headers[key]);
  });

  request.send(JSON.stringify(body));
}
